export enum SENDER {
  USER = 'user',
  BOT = 'bot',
}

export type SenderType = `${SENDER}`;

export interface MessageButtonLink {
  link: string;
  text: string;
}

export interface MessageFollowUpOption {
  label: string;
  action: string;
}

export interface MessageButtons {
  links?: MessageButtonLink[];
  inMessageOptions?: MessageFollowUpOption[];
  otherOptions?: MessageFollowUpOption[];
}

export interface SplitBillResult {
  payer: string;
  participants: string[];
  split: Record<string, number>;
  total: number;
  description: string;
}

import {
  ISplitBill,
  ISplitBillGroup,
} from '@/dataSource/src/api/split-bills/entities';

export interface Message {
  id: string;
  text: string;
  from: SenderType;
  result?: boolean;
  splitBill?: SplitBillResult;
  rawSplitBill?: ISplitBill;
  rawSplitBillGroup?: ISplitBillGroup;
  filePreview?: string | null;
  date: Date;
  showSupport?: boolean;
  buttons?: MessageButtons;
  splitId?: string;
  selectedInMessageOption?: string;
}

export interface IPutSplitBillsImage {
  file: File;
}

export interface SplitBillsViewModelContextType {
  messages: Message[];
  sendMessage: (text: string) => void;
  onFollowUpOptionPress: (
    option: MessageFollowUpOption,
    messageId: string,
  ) => void;
  isLoading: boolean;
  isSplitAdded: boolean;
  splitCreateError: boolean;
  lastCreatedSplitId: string | null;
  fileImagesPreview: string | null;
  setFileImagesPreview: (preview: string | null) => void;
  onButtonPress?: () => void;
  onClearConversationPress?: () => void;
  onSplitAdd?: () => void;
  onSplitUndo?: () => void;
  isCreatingSplit?: boolean;
  handlePostBillSubmitted?: (
    document: IPutSplitBillsImage,
    sessionId?: string,
  ) => Promise<string>;
  handleSaveFileImage?: (file: File) => Promise<void>;
  stopMessage: () => void;
  openFreshChat: () => void;
  walkThroughTheApp: () => void;
  hideDisclaimer: boolean;
  isSupportLoading: boolean;
  onButtonDeepLinkPress: (link: string) => void;
  shouldShowGroupActions?: boolean;
  shouldShowShareLinkCard?: boolean;
}
